module.exports = __webpack_public_path__ + "static/img/img_form_1_ja.e9073b41.png";